import React from 'react';
import { connect } from 'react-redux';
import { IoIosHelpCircleOutline } from 'react-icons/io';
import { AiOutlineInfoCircle, AiOutlinePoweroff } from 'react-icons/ai';
import { useHistory } from 'react-router-dom';
import { GrDiamond } from 'react-icons/gr';
import { BiSolidBadgeCheck } from 'react-icons/bi';
import { FaVault } from 'react-icons/fa6';
import { ConnectionController } from '@reown/appkit-core';
import SettingsItem from '../../SettingsItem';
import s from './style.css';
import { auth, iap } from '../../../actions';
import { colors } from '../../../foundations';
import { shortenAddress } from '../../../utils';
const SettingsMenu = (props) => {
    const history = useHistory();
    const actions = [
        {
            text: 'My Vault',
            icon: React.createElement(FaVault, { color: '#0F0F28' }),
            onClick: () => {
                props.setVisible(false);
                history.push('/vault/files');
            },
        },
        {
            text: 'Support',
            icon: React.createElement(IoIosHelpCircleOutline, { color: '#0F0F28' }),
            onClick: () => {
                props.setVisible(false);
                history.push('/support');
            },
        },
        {
            text: 'Sticknet Premium',
            icon: React.createElement(GrDiamond, { color: '#0F0F28' }),
            onClick: () => {
                props.setVisible(false);
                history.push('/premium');
            },
        },
        {
            text: 'Log Out',
            icon: React.createElement(AiOutlinePoweroff, { color: '#0F0F28' }),
            onClick: async () => {
                await ConnectionController.disconnect();
                props.logout(() => {
                    props.setVisible(false);
                    history.push('/');
                });
            },
        },
    ];
    if (!props.visible)
        return null;
    return (React.createElement("div", { className: s.menuContainer, onClick: (e) => e.stopPropagation(), onKeyDown: (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.stopPropagation();
            }
        }, role: 'button', tabIndex: 0 },
        React.createElement("div", { className: s.infoContainer },
            React.createElement("div", { className: s.nameContainer },
                React.createElement("p", { className: s.name }, props.user?.name),
                !props.isBasic && React.createElement(BiSolidBadgeCheck, { style: { marginLeft: 4 }, size: 20, color: colors.primary })),
            React.createElement("p", { className: s.email },
                "Username: ",
                React.createElement("b", null,
                    "@",
                    props.user?.username)),
            props.user?.email ? (React.createElement("p", { className: s.email },
                "Email: ",
                React.createElement("b", null, props.user?.email))) : (React.createElement("p", { className: s.email },
                "Wallet Address: ",
                React.createElement("b", null, shortenAddress(props.user?.ethereumAddress))))),
        actions.map((item) => (React.createElement(SettingsItem, { key: item.text, icon: item.icon, text: item.text, onClick: item.onClick, danger: item.danger }))),
        React.createElement("div", { className: s.noteContainer },
            React.createElement(AiOutlineInfoCircle, { color: '#8d8d8d', size: 14 }),
            React.createElement("p", { className: s.note }, "You can access your network, chats, and profile from a mobile device."))));
};
const mapStateToProps = (state) => ({
    user: state.auth.user,
    isBasic: !state.auth.user || state.auth.user.subscription === 'basic',
});
const connector = connect(mapStateToProps, { ...auth, ...iap });
export default connector(SettingsMenu);
